import axios from 'axios';

import { API_PATH } from '../formsServiceConfig';
import { CUSTOMER_NAME } from '../constants';
import { responseSuccess, responseError } from './interceptors';

const HTTP = axios.create({
    baseURL: `${API_PATH}/${CUSTOMER_NAME}/api/1/forms`,
    withCredentials: true
});

HTTP.interceptors.response.use(responseSuccess, responseError);

export default HTTP;
